/**
 * Calculate padding based on font size
 * Bigger font = Less padding (to fit in box)
 * Smaller font = More padding (comfortable spacing)
 *
 * @param fontSize - Current font size in pixels
 * @param minFontSize - Minimum font size
 * @param maxFontSize - Maximum font size
 * @param maxPadding - Padding at minimum font size
 * @param minPadding - Padding at maximum font size (default: 0)
 * @returns Calculated padding in pixels, clamped to [minPadding, maxPadding]
 */
export const calculateDynamicPadding = (
  fontSize: number,
  minFontSize: number,
  maxFontSize: number,
  maxPadding: number,
  minPadding = 0,
): number => {
  // If font is too small, use big padding
  if (fontSize <= minFontSize) return maxPadding;

  // If font is too big, use small padding
  if (fontSize >= maxFontSize) return minPadding;

  // In between: calculate
  const difference = maxFontSize - minFontSize;
  const howMuchBigger = fontSize - minFontSize;
  const percentage = howMuchBigger / difference;

  const paddingDifference = maxPadding - minPadding;
  const padding = maxPadding - percentage * paddingDifference;

  return Math.round(padding);
};
